<app-headersecond></app-headersecond>
<section class="section banner">
  <div class="container"> 
    <div class="section-box-banner">
      <div>
       <p class="text-h3">Editar</p><p class="text-h2"> descripcion del Banner </p>
    
        <form *ngIf="bannerForm" [formGroup]="bannerForm" (ngSubmit)="onSubmit()">
            <mat-form-field  class="custom-mat-input">
              <mat-label class="cine">Descripción</mat-label>
              <textarea class="custom-textarea" maxlength="200" matInput matTextareaAutosize matAutosizeMinRows="6" matAutosizeMaxRows="10"  placeholder="description" formControlName="description"></textarea>
              <div class="mat-hint-div">
              <mat-hint class="mat-hint" align="end">
                {{200 - bannerForm.controls.description.value.length}} caracteres restantes
              </mat-hint></div>
            </mat-form-field>
            <div *ngIf="bannerForm.controls.description.invalid && bannerForm.controls.description.touched" class="text-danger">
              <div *ngIf="bannerForm.controls.description.errors.required">La descripción es obligatoria.</div>
            </div>
            <div class="mb-0">
              <button class="main-btn" type="submit" [disabled]="bannerForm.invalid" [ngClass]="{'disabled-button':bannerForm.invalid}">Guardar cambios</button>
        </div>
          </form>
          
        </div>
      </div>
    </div>
  </section>